import { CardTravel } from '@material-ui/icons';
import { handleActions } from 'redux-actions';

import { types } from '../constants';
import { documentType } from '../constants';

const INITIAL_STATE = {
  allDocuments: {
    items: [],
    itemsCopy: [],
    isLoading: false,
    errorMessage: ''
  },
  openDocumentListDialog: false,
  breadCrumbItems: [],
  defaultDirectory: '',
  currentDirectory: ''
};

const startFetchAllDocuments = (state, { currentDocumentType, branchId }) => {
 
  let currentType = getCurrentDirectory(currentDocumentType, branchId);
  var breadCrumbStack = state.breadCrumbItems;
  breadCrumbStack.push(currentType);

  let defaultDir = getParentDirectory(currentDocumentType);
  return {
    ...state,
    allDocuments: {
      ...state.allDocuments,
      items: [],
      itemsCopy: [],
      isLoading: true
    },
    breadCrumbItems: breadCrumbStack,
    defaultDirectory: defaultDir,
    currentDirectory: currentType
  };
};

const getCurrentDirectory = (currentDocumentType,
  branchId) => {
  switch (currentDocumentType) {
    case 1:
      return 'Documents/';
    case 2:
      return 'Library/';
    case 3:
      return 'Branch Documents/branch-' + branchId + '/';
    default:
      return 'Documents/';
  }
};

const getParentDirectory = (currentDocumentType) => {
  switch (currentDocumentType) {
    case 1:
      return 'Documents/';
    case 2:
      return 'Library/';
    case 3:
      return 'Branch Documents/';
    default:
      return 'Documents/';
  }
};

const fetchAllDocumentsSuccess = (state, { allDocuments }) => {

  const defaultDirectory = state.currentDirectory;
  const firstHierarchy = allDocuments.filter(
    (x) => x.parentId === defaultDirectory
  );
  return {
    ...state,
    allDocuments: {
      ...state.allDocuments,
      itemsCopy: allDocuments,
      items: firstHierarchy
    }
  };
};

const fetchAllDocumentsFailure = (state, { errorMessage }) => {
  return {
    ...state,
    allDocuments: {
      ...state.allDocuments,
      errorMessage
    }
  };
};

const fetchAllDocumentsFinished = (state) => {
  return {
    ...state,
    allDocuments: {
      ...state.allDocuments,
      isLoading: false
    }
  };
};

const openDocumentListDialog = (state, { open }) => {
  return {
    ...state,
    openDocumentListDialog: open
  };
};

const resetDocumentsToOriginalState = (state) => {
  const defaultItems = state.allDocuments.itemsCopy;
  const defaultDir = state.defaultDirectory;
  const firstHierarchy = defaultItems.filter((x) => x.parentId === defaultDir);
  return {
    allDocuments: {
      ...state.allDocuments,
      itemsCopy: defaultItems,
      items: firstHierarchy
    },
    currentDirectory: defaultDir,
    breadCrumbItems: [],
    defaultDirectory: '',
    currentDirectory: ''
  };
};

const resetFormat = (state) => {
  return {
    allDocuments: {
      ...state.allDocuments,
      itemsCopy: [],
      items: []
    },
    currentDirectory: '',
    breadCrumbItems: [],
    defaultDirectory: '',
    currentDirectory: ''
  };
};

const showDocumentFolderItems = (state, { prefix }) => {
  const allDocuments = state.allDocuments.itemsCopy;
  var defaultDirectory = state.defaultDirectory;
  var currentBreadCrumb = defaultDirectory.concat(prefix);
  var breadCrumbStack = state.breadCrumbItems;
  breadCrumbStack.push(currentBreadCrumb);
  var itemsForCurrentDirectory = allDocuments.filter(
    (x) => x.parentId === currentBreadCrumb
  );
  return {
    ...state,
    allDocuments: {
      ...state.allDocuments,
      itemsCopy: allDocuments,
      items: itemsForCurrentDirectory
    },
    currentDirectory: currentBreadCrumb,
    breadCrumbItems: breadCrumbStack
  };
};

const showLastDocumentHierarchy = (state) => {
  var breadCrumbStack = state.breadCrumbItems;
  breadCrumbStack.pop();
  var lastDir = breadCrumbStack[breadCrumbStack.length - 1];
  const allDocuments = state.allDocuments.itemsCopy;

  var itemsForCurrentDirectory = allDocuments.filter(
    (x) => x.parentId === lastDir
  );
  return {
    ...state,
    allDocuments: {
      ...state.allDocuments,
      itemsCopy: allDocuments,
      items: itemsForCurrentDirectory
    },
    currentDirectory: lastDir
  };
};


const getProperCurretnPath = (fullPath, folderName) => {
  if (
    typeof fullPath !== 'undefined' &&
    fullPath !== null
  ){
    var allPaths = fullPath.split('/').filter(x => x !== "");  
    
    if(allPaths.length > 1){
      allPaths.shift();
      var joined = allPaths.length === 1 ? allPaths[0] :  allPaths.join('/');
      return joined.concat('/' + folderName, '/')
    }
    else{
      return folderName + '/';
    }
  }
  else{
    return folderName + '/';    
  }
}

const folderAdded = (state , { folderName }) => {

  var currentPath = state.currentDirectory;
  var folderPath = getProperCurretnPath(currentPath, folderName);
 var breadCrumbStack = state.breadCrumbItems;
 var lastDir = breadCrumbStack[breadCrumbStack.length - 1];
 
 const newFolder = {
   documentName: folderPath,
   folderName,
   blobName: "",
   isFolder: true,
   parentId: lastDir,
   blobFullUrl: null
 };

 const allDocuments = state.allDocuments.itemsCopy;
 allDocuments.push(newFolder);
 var itemsForCurrentDirectory = allDocuments.filter(
  (x) => x.parentId === lastDir
);

return {
  ...state,
  allDocuments: {
    ...state.allDocuments,
    itemsCopy: allDocuments,
    items: itemsForCurrentDirectory
  }
};

}




//Add Attachment

const startAddAttachment = (state) => {
  return {
    ...state,
    allDocuments: {
      ...state.allDocuments,
      isLoading: true
    }
  };
};


const addDocumentSuccess = (state, {attachment}) => {
  const allDocuments = state.allDocuments.itemsCopy;
  
  if(typeof attachment !== 'undefined'){
    allDocuments.push(attachment);
  }
 
  const currentDirectory = state.currentDirectory;

  const firstHierarchy = allDocuments.filter(
    (x) => x.parentId === currentDirectory
  );
  return {
    ...state,
    allDocuments: {
      ...state.allDocuments,
      itemsCopy: allDocuments,
      items: firstHierarchy
    }
  };

};


const addAttachmentFailure = (state, { errorMessage }) => {
  return {
    ...state,
    allDocuments: {
      ...state.allDocuments,
      errorMessage
    }
  };
};

const addAttachmentFinished = (state) => {
  return {
    ...state,
    allDocuments: {
      ...state.allDocuments,
      isLoading: false
    }
  };
};


//Remove Attachment

const startRemoveAttachment = (state) => {
  return {
    ...state,
    allDocuments: {
      ...state.allDocuments,
      isLoading: true
    }
  };
};


const removeAttachmentSuccess = (state, {blobName
}) => {
 
  const currentDocuments = state.allDocuments.itemsCopy;
  let filterdDocuments = [];
  if(typeof blobName !== 'undefined'){
    try{
      filterdDocuments = currentDocuments.filter((x) => x.documentName !== blobName);
    }
    catch(error){
        console.log(error);
    }
  }

  const currentDirectory = state.currentDirectory;
  const firstHierarchy = filterdDocuments.filter(
    (x) => x.parentId === currentDirectory
  );
  
  return {
    ...state,
    allDocuments: {
      ...state.allDocuments,
      itemsCopy: filterdDocuments,
      items: firstHierarchy
    }
  };

};


const removeAttachmentFailure = (state, { errorMessage }) => {
  return {
    ...state,
    allDocuments: {
      ...state.allDocuments,
      errorMessage
    }
  };
};

const removeAttachmentFinished = (state) => {
  return {
    ...state,
    allDocuments: {
      ...state.allDocuments,
      isLoading: false
    }
  };
};



//Handles the incoming actions.
export default handleActions(
  {
    [types.START_FETCH_ALL_DOCUMENTS]: startFetchAllDocuments,
    [types.FETCH_ALL_DOCUMENTS_SUCCESS]: fetchAllDocumentsSuccess,
    [types.FETCH_ALL_DOCUMENTS_FAILURE]: fetchAllDocumentsFailure,
    [types.FETCH_ALL_DOCUMENTS_FINISHED]: fetchAllDocumentsFinished,

    [types.OPEN_DOCUMENT_LIST_DIALOG]: openDocumentListDialog,

    [types.DOCUMENT_SHOW_FOLDER_ITEMS]: showDocumentFolderItems,
    [types.DOCUMENT_BACK_ARROW_CLICKED]: showLastDocumentHierarchy,

    [types.DOCUMENT_RESET_ORIGINAL_STATE]: resetDocumentsToOriginalState,

    [types.FOLDER_ADDED]: folderAdded,

    

    [types.START_USER_ATTACHMENT_ADD]: startAddAttachment,
    [types.USER_ATTACHMENT_ADD_SUCCESS]: addDocumentSuccess,
    [types.USER_ATTACHMENT_ADD_FAILURE]: addAttachmentFailure,
    [types.USER_ATTACHMENT_ADD_FINISHED]: addAttachmentFinished,


    [types.START_USER_ATTACHMENT_REMOVE]: startRemoveAttachment,
    [types.USER_ATTACHMENT_REMOVE_SUCCESS]: removeAttachmentSuccess,
    [types.USER_ATTACHMENT_REMOVE_FAILURE]: removeAttachmentFailure,
    [types.USER_ATTACHMENT_REMOVE_FINISHED]: removeAttachmentFinished,

    [types.FULL_RESET_DOCUMENTS]: resetFormat,
  },
  INITIAL_STATE


);

